import createAxiosInstance from './axiosInstance';
import axios from 'axios';
import Cookies from 'js-cookie';
export { createAxiosInstance, axios, Cookies };
export default createAxiosInstance;